export default {
    tareasProgramadas: []
}